// userNome — resolve o NOME do usuário logado a partir do storage local.
// Par do utils/userEmail (PO1-2082). O nome NÃO está no JWT (loggedUser só
// tem id/email); o login (backend_hub SessionService) guarda o usuário em
// "@HubEverlog:user" como { id, name, surname, username, ... }. Usamos
// name (+ surname quando houver). Best-effort: retorna null se não achar.

export default function obterUserNome() {
  try {
    const userRaw = localStorage.getItem("@HubEverlog:user");
    if (!userRaw) return null;
    const u = JSON.parse(userRaw);
    if (!u || typeof u !== "object") return null;
    const nome = [u.name, u.surname]
      .map((p) => (p == null ? "" : String(p).trim()))
      .filter(Boolean)
      .join(" ")
      .trim();
    return nome || null;
  } catch (_) {
    return null;
  }
}
